import { useContext } from 'react';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _keys from 'lodash/keys';
import { AppContext, UserContext } from 'commons-ui';

import { PAGE_NAMES } from 'constant';

export interface HasPermissionArgument {
	entity?: string;
	configPageName: string;
	action?: string;
	appName?: any;
}

const usePermission = () => {
	const { roleConfig, logoutUser } = useContext(UserContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const hasPermission = ({ configPageName, entity, action }: HasPermissionArgument): boolean => {
		const { role, roleActions } = roleConfig || { role: 'ADMIN', roleActions: {} };
		if (!roleActions) {
			logoutUser();
			return false;
		}
		const path = [];
		if (configPageName !== PAGE_NAMES.settings) {
			path.push('appEntity');
			path.push(appName);
		}
		path.push(configPageName);
		if (entity) {
			path.push(entity);
		}
		if (action) {
			path.push(action);
		}
		if (role === 'ADMIN') {
			return true;
		}

		const permission = _get(roleActions, path);

		if (_isNil(permission) || _isObject(permission && _isEmpty(permission))) {
			return false;
		}
		return permission;
	};

	const getFirstAccessibleEntityURL = (configPageName: string) => {
		const { roleActions } = roleConfig;
		let entities: any;
		if (configPageName === PAGE_NAMES.settings) {
			entities = _get(roleActions, [configPageName]);
		} else if (appName) {
			entities = _get(roleActions, ['appEntity', appName, configPageName]);
		}
		return _find(_keys(entities), (entityName) => !_isEmpty(entities[entityName]));
	};

	return {
		hasPermission,
		getFirstAccessibleEntityURL
	};
};

export default usePermission;
